import React from 'react';
import { Box, Avatar } from '@mui/material';

interface FarmAvatarProps {
  avatar: {
    type: 'shape' | 'image';
    data: string;
  };
  size?: number;
  onClick?: () => void;
}

const FarmAvatar: React.FC<FarmAvatarProps> = ({ avatar, size = 40, onClick }) => {
  if (avatar.type === 'image') {
    return (
      <Avatar
        src={avatar.data}
        sx={{ width: size, height: size, cursor: onClick ? 'pointer' : 'default' }}
        onClick={onClick}
      />
    );
  }

  // Parse shape data
  const parts = avatar.data.split(':');
  const shape = parts[0];
  const style = parts[1];
  const color1 = parts[2];
  const color2 = parts[3];
  const angle = parts[4] || '45';

  const shapes: Record<string, string> = {
    circle: 'M 50 50 m -40 0 a 40 40 0 1 0 80 0 a 40 40 0 1 0 -80 0',
    square: 'M 10 10 h 80 v 80 h -80 z',
    hexagon: 'M 50 5 L 85 25 L 85 75 L 50 95 L 15 75 L 15 25 Z',
    star: 'M 50 5 L 61 35 L 95 35 L 68 55 L 79 85 L 50 65 L 21 85 L 32 55 L 5 35 L 39 35 Z',
    shield: 'M 50 10 L 80 20 L 80 50 Q 80 80 50 90 Q 20 80 20 50 L 20 20 Z',
    leaf: 'M 50 90 Q 20 60 20 30 Q 20 10 40 10 Q 50 10 50 20 Q 50 10 60 10 Q 80 10 80 30 Q 80 60 50 90',
  };

  const gradientId = `gradient-${shape}-${Date.now()}`;

  return (
    <Box
      onClick={onClick}
      sx={{ 
        width: size, 
        height: size, 
        cursor: onClick ? 'pointer' : 'default',
        borderRadius: shape === 'circle' ? '50%' : 0,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <svg width={size} height={size} viewBox="0 0 100 100">
        {style === 'gradient' && (
          <defs>
            <linearGradient 
              id={gradientId} 
              x1="0%" 
              y1="0%" 
              x2="100%" 
              y2="100%" 
              gradientTransform={`rotate(${angle} 50 50)`}
            >
              <stop offset="0%" stopColor={color1} />
              <stop offset="100%" stopColor={color2} />
            </linearGradient>
          </defs>
        )}
        <path 
          d={shapes[shape] || shapes.circle} 
          fill={style === 'gradient' ? `url(#${gradientId})` : color1}
        />
      </svg>
    </Box>
  );
};

export default FarmAvatar;